'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dataKey = exports.dataKey = 'text';


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-form-nullable/lib/util/eventConsts.js
 ** module id = 361
 ** module chunks = 3
 **/